import axios from 'axios';
import i18n from '../i18n';

export interface ApiError {
  title: string;
  message: string;
}

export function mapLoginError(err: unknown): ApiError {
  if (axios.isAxiosError(err)) {
    const status = err.response?.status;
    if (status === 401)
      return {
        title: i18n.t('auth.errori.credenziali_titolo'),
        message: i18n.t('auth.errori.credenziali_testo'),
      };
    if (status === 403)
      return {
        title: i18n.t('auth.errori.account_disattivato_titolo'),
        message: i18n.t('auth.errori.account_disattivato_testo'),
      };
    if (status === 422)
      return {
        title: i18n.t('auth.errori.dati_non_validi_titolo'),
        message: i18n.t('auth.errori.dati_non_validi_testo'),
      };
    if (!err.response)
      return {
        title: i18n.t('auth.errori.connessione_titolo'),
        message: i18n.t('auth.errori.connessione_testo'),
      };
  }
  return {
    title: i18n.t('auth.errori.inatteso_titolo'),
    message: i18n.t('auth.errori.inatteso_testo'),
  };
}
